'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\tmargin-top: 15px;\n'], ['\n\tmargin-top: 15px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\tmargin-top: -1px;\n\tborder-radius: ', ';\n\tborder: 1px solid ', ';\n'], ['\n\tmargin-top: -1px;\n\tborder-radius: ', ';\n\tborder: 1px solid ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n\tpadding-left: 10px;\n'], ['\n\tpadding-left: 10px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n\theight: 42px;\n\tbackground-color: ', ';\n\tdisplay: flex;\n\talign-items: center;\n\t', ';\n\n\t', ' ', '\n\n    &:hover {\n\t\tbackground-color: ', ';\n\t}\n'], ['\n\theight: 42px;\n\tbackground-color: ', ';\n\tdisplay: flex;\n\talign-items: center;\n\t', ';\n\n\t', ' ', '\n\n    &:hover {\n\t\tbackground-color: ', ';\n\t}\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n\tpadding: 1px 1px 1px 0px;\n\theight: 41px;\n\tbackground-color: ', ';\n\tdisplay: flex;\n\talign-items: center;\n\t', ';\n\t', ';\n\t', ';\n'], ['\n\tpadding: 1px 1px 1px 0px;\n\theight: 41px;\n\tbackground-color: ', ';\n\tdisplay: flex;\n\talign-items: center;\n\t', ';\n\t', ';\n\t', ';\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n\tmargin-bottom: 10px;\n'], ['\n\tmargin-bottom: 10px;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _alignments = require('../../../constants/alignments');

var _colors = require('../../../constants/colors');

var _sizes = require('../../../constants/sizes');

var _styles = require('../../../atoms/link/styles');

var _label = require('../../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

var _container = require('../../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _radius = require('../../../constants/radius');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ListGroupWrapper = _styledComponents2.default.div(_templateObject);

var List = _styledComponents2.default.div(_templateObject2, _radius.Radius.large, _colors.Colors.cello);

var PaddedWrapper = _styledComponents2.default.div(_templateObject3);

var Item = _styledComponents2.default.div(_templateObject4, _colors.Colors.LightMode, _styles.Link1Styles, function (_ref) {
	var index = _ref.index,
	    lastItem = _ref.lastItem;
	return index === 0 ? 'border-radius:' + _radius.Radius.large + ' ' + _radius.Radius.large + ' 0px 0px;' : lastItem ? 'border-radius:0px 0px ' + _radius.Radius.large + ' ' + _radius.Radius.large + ';' : '';
}, function (_ref2) {
	var lastItem = _ref2.lastItem;
	return !lastItem && 'border-bottom: 1px solid ' + _colors.Colors.cello + ';';
}, function (_ref3) {
	var disabled = _ref3.disabled;
	return disabled ? _colors.Colors.LightMode : _colors.Colors.cello5;
});

var SelectedItem = _styledComponents2.default.div(_templateObject5, _colors.Colors.aqua, function (_ref4) {
	var index = _ref4.index,
	    lastItem = _ref4.lastItem;
	return index === 0 ? 'border-radius:' + _radius.Radius.large + ' ' + _radius.Radius.large + ' 0px 0px;' : lastItem ? 'border-radius:0px 0px ' + _radius.Radius.large + ' ' + _radius.Radius.large + ';' : '';
}, function (_ref5) {
	var lastItem = _ref5.lastItem;
	return !lastItem && 'border-bottom: 1px solid ' + _colors.Colors.cello + ';';
}, _styles.Link1Styles);

var LabelWrapper = _styledComponents2.default.div(_templateObject6);

var CenteringWrapper = _styledComponents2.default.div(_templateObject7, function (_ref6) {
	var centered = _ref6.centered;
	return centered && 'margin:auto;';
});

var ListGroup = function (_React$Component) {
	_inherits(ListGroup, _React$Component);

	function ListGroup() {
		_classCallCheck(this, ListGroup);

		return _possibleConstructorReturn(this, (ListGroup.__proto__ || Object.getPrototypeOf(ListGroup)).apply(this, arguments));
	}

	_createClass(ListGroup, [{
		key: 'getIsComplete',
		value: function getIsComplete() {
			return this.props.mode === 'single' && this.props.selections.length > 0 || this.props.mode === 'multiple' && this.props.selections.length === (this.props.limit || this.props.references.length);
		}
	}, {
		key: 'handleClickEvent',
		value: function handleClickEvent(item) {
			var selectedItems = this.props.selections;

			var selectedItem = selectedItems.find(function (selectedItemVal) {
				return selectedItemVal.code === item.code;
			});

			if (selectedItem) {
				selectedItems.splice(selectedItems.indexOf(selectedItem), 1);
			} else {
				selectedItems.push(item);
			}

			this.props.clickEvent(selectedItems);
		}
	}, {
		key: 'handleNullOptionClick',
		value: function handleNullOptionClick() {
			this.props.clickEvent([]);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_container2.default,
				null,
				_react2.default.createElement(
					CenteringWrapper,
					null,
					_react2.default.createElement(
						LabelWrapper,
						null,
						this.props.label && _react2.default.createElement(_label2.default, { textAlign: _alignments.Alignments.left, text: this.props.label })
					),
					_react2.default.createElement(
						List,
						null,
						this.props.references && this.props.references.map(function (item, index) {
							var selected = _this2.props.selections.some(function (x) {
								return x.code === item.code;
							});

							var element = void 0;

							if (selected) {
								element = _react2.default.createElement(
									SelectedItem,
									{
										index: index,
										lastItem: index === _this2.props.references.length - 1 && !_this2.props.nullOption,
										key: index,
										onClick: function onClick() {
											return _this2.handleClickEvent(item);
										}
									},
									_react2.default.createElement(
										PaddedWrapper,
										null,
										item.value
									)
								);
							} else {
								element = _react2.default.createElement(
									Item,
									{
										index: index,
										key: index,
										lastItem: index === _this2.props.references.length - 1 && !_this2.props.nullOption,
										onClick: function onClick() {
											return _this2.getIsComplete() || _this2.handleClickEvent(item);
										},
										disabled: _this2.getIsComplete()
									},
									_react2.default.createElement(
										PaddedWrapper,
										null,
										item.value
									)
								);
							}

							return element;
						}).concat(this.props.nullOption && (!this.props.selections || this.props.selections.length === 0 ? _react2.default.createElement(
							SelectedItem,
							{
								index: this.props.references.length,
								lastItem: true,
								key: this.props.references.length,
								onClick: function onClick() {
									return _this2.handleNullOptionClick();
								}
							},
							_react2.default.createElement(
								PaddedWrapper,
								null,
								this.props.nullOptionText
							)
						) : _react2.default.createElement(
							Item,
							{
								index: this.props.references.length,
								lastItem: true,
								key: this.props.references.length,
								onClick: function onClick() {
									return _this2.handleNullOptionClick();
								}
							},
							_react2.default.createElement(
								PaddedWrapper,
								null,
								this.props.nullOptionText
							)
						)))
					)
				)
			);
		}
	}]);

	return ListGroup;
}(_react2.default.Component);

exports.default = ListGroup;